import { FontSizes, FontWeights, NeutralColors, mergeStyleSets } from "@fluentui/react";

const popupFocusStyle = {
  outline: "2px solid #323130",
  outlineOffset: -2,
  selectors: {
    "@media (forced-colors: active)": {
      outline: "2px solid CanvasText",
      outlineOffset: -2,
      forcedColorAdjust: "none" as const,
    }
  }
};

export const menuStyles = mergeStyleSets({
  longText: {
    width: "208px",
    height: "56px",
    justifyContent: "space-between",
    "&:focus": {
      outline: "2px solid #fff",
      outlineOffset: -2,
      border: "none"
    }
  },
  wrapper: {
    padding: "2px 16px",
    color: NeutralColors.white,
    span: {
      color: NeutralColors.white,
    },
    "&:hover": {
      background: NeutralColors.gray170,
      "span": {
        color: NeutralColors.white,
      },
    },
    "&:active": {
      background: NeutralColors.gray140,
      "span": {
        color: NeutralColors.white,
      },
    },
  },
  menuButonContent: {
    display: "flex",
    flexDirection: "column",
    textAlign: "left",
    width: 180,
    paddingRight: 16
  },
  menuButonContentSecondary: {
    display: "flex",
    justifyContent: "space-between",
    gap: 8,
    span: {
      flex: 1
    }
  },
  menuPopover: {
    maxWidth: "400px !important",
    height: "496px !important",
    maxHeight: "496px !important",
    background: "#FAF9F8!important",
    border: "none !important",
    borderRadius: "2 !important",
    boxShadow: "0px 6.4px 14.4px 0px rgba(0, 0, 0, 0.13), 0px 1.2px 3.6px 0px rgba(0, 0, 0, 0.10)!important",
  },
  MenuItemRadio: {
    maxWidth: "400px !important",
    minWidth: "340px !important",
    padding: "8px 24px 8px 8px !important",
    gap: "0px !important",
    "&:focus": {
      ...popupFocusStyle,
      border: "none"
    },
    "span:nth-child(1)": {
      width: "auto"
    },
    "span:not(:nth-child(1))": {
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis",
    },
  },
  menuRowButton: {
    width: "100%",
    background: "transparent",
    textAlign: "left",
    cursor: "pointer",
    display: "block",
    position: "relative",
    minHeight: 44,
    padding: "10px 24px",
    margin: 0,
    font: "inherit",
    color: "inherit",
    appearance: "none",
    WebkitAppearance: "none",
    borderTop: "none",
    borderRight: "none",
    borderBottom: "none",
    borderLeft: "none",
    selectors: {
      "&:hover": {
        background: "transparent"
      },
      "&:active": {
        background: "transparent"
      },
      "&:focus": {
        ...popupFocusStyle,
      }
    }
  },
  accountRow: {
    width: "100%",
    display: "block",
    position: "relative",
    margin: 0,
    background: "#fff",
    boxSizing: "border-box",
    selectors: {
      "&::after": {
        content: "\"\"",
        position: "absolute",
        left: 0,
        right: 0,
        bottom: 0,
        height: 1,
        background: "#E1DFDD",
        pointerEvents: "none",
      },
      "&:hover": {
        background: "#F8F8F8"
      },
      "&:active": {
        background: "#edebe9"
      },
      "&:focus-within": {
        ...popupFocusStyle,
        zIndex: 1,
      }
    }
  },
  menuRowLabel: {
    width: "100%",
    background: "transparent",
    textAlign: "left",
    cursor: "pointer",
    display: "block",
    minHeight: 44,
    padding: "10px 24px 10px 13px",
    margin: 0,
    color: "inherit",
    borderTop: "none",
    borderRight: "none",
    borderBottom: "none",
    borderLeft: "none",
    boxSizing: "border-box",
    selectors: {
      "&:hover": {
        background: "transparent"
      }
    }
  },
  radioInput: {
    position: "absolute",
    left: -9999,
    top: "auto",
    opacity: 0,
    pointerEvents: "none",
    width: 1,
    height: 1,
    margin: 0,
    padding: 0,
    border: 0,
    overflow: "hidden",
    clip: "rect(0 0 0 0)",
    clipPath: "inset(50%)",
    whiteSpace: "nowrap",
    appearance: "none",
    WebkitAppearance: "none",
  },
  selectedAccountRow: {
    background: "#fff",
    selectors: {
      "&::before": {
        content: "\"\"",
        position: "absolute",
        left: 0,
        top: 8,
        bottom: 8,
        width: 4,
        background: "#0078D4",
      }
    }
  },
  cidItemRadio: {
    minHeight: 44,
    padding: "10px 24px !important"
  },
  customerInfo: {
    flexGrow: 1,
    width: "100%",
    alignItems: "center",
    justifyContent: "space-between",
    gap: 6,
    "div": {
      flex: 2,
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis",
      minHeight: 24,
      lineHeight: "24px"
    },
    "div:nth-child(2)": {
      flex: 1,
      textAlign: "right",
      minHeight: 24,
      lineHeight: "24px",
      display: "flex",
      alignItems: "center",
      justifyContent: "flex-end",
    }
  },
  customerTitleInfo: {
    flexGrow: 1,
    alignItems: "center",
    "div": {
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis",
      minHeight: 24,
      lineHeight: "24px"
    },
    "div:nth-child(2)": {
      flexGrow: 1,
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis",
      minHeight: 24,
      lineHeight: "24px",
      display: "flex",
      alignItems: "center",
    }
  },
  AccountMenuItemRadio: {
    borderBottom: "1px solid #ccc",
  },
  Text: {
    fontSize: FontSizes.size14,
    fontWeight: FontWeights.bold,
    height: 30,
    lineHeight: 30,
    display: "block",
    padding: "0 24px",
    margin: 0,
  },
  accountItem: {
    background: "#fff",
    margin: "0px 24px 12px 24px",
    ">div": {
      overflowY: "auto",
      minHeight: 300,
      height: 300,
      overflowX: "hidden"
    }
  }
});
